import { HTMLInputAutoCompleteAttribute } from "react";
import { FieldValues, Path, useWatch } from "react-hook-form";

import { getCountryFormatting } from "@/services/zipCode.service.RHF";

import { FormValuesExploded, StringPath } from "../formField.types";
import { MaskedField } from "../MaskedField/maskedField.component";

type ZipCodeFieldProps<T extends FieldValues> = FormValuesExploded<T> & {
    countryPath: StringPath<T>;
    autoComplete?: HTMLInputAutoCompleteAttribute;
    disabled?: boolean;
};

const ZipCodeField = <T extends FieldValues>({
    countryPath,
    ...props
}: ZipCodeFieldProps<T>) => {
    const country = useWatch<T>({ name: countryPath as Path<T> });

    return (
        <MaskedField<T>
            {...props}
            inputMask={getCountryFormatting(country.toUpperCase())}
        />
    );
};

export { ZipCodeField };
